import request from '@/utils/request'
import { BASE_API } from '@/utils/consts'

// 诊所员工列表查询
export function queryClinicEmployees(clinicId) {
  return request(`${BASE_API}/employee/list_by/${clinicId}`);
}

// 查询诊所已创建订单的用户
export function queryOrderEmployees(data) {
  return request(`${BASE_API}/order/list_order_employee`, {
    method: 'post',
    data
  });
}
// 查询诊所已创建订单的用户
export function queryOrderEmployees2(data) {
  return request(`${BASE_API}/order/list_order_employee_2`, {
    method: 'post',
    data
  });
}

export function queryEmployees(clinicId) {
  return request(`${BASE_API}/employee/list_by`);
}
// 顾问列表
export function queryEmployeesByClinicId(data) {
  return request(`${BASE_API}/employee/list_by2`,{ data });
}